import styled from 'styled-components';
import { Text } from 'shared/components/Text/Text';

export const TpvBaseContainer = styled.div`
  width: 100%;
  max-width: 416px;
`;

export const ModalHeader = styled(Text)`
  font-weight: 500;
  font-size: 24px;
  margin-bottom: 20px;
  text-align: center;
`;

export const ModalText = styled(Text)`
  ${({ theme }) => `
    color: ${theme.colors.textSecondaryGrey90};
    &:not(:last-of-type) {
      margin-bottom: 16px;
    }
    strong {
      font-weight: 700;
    }
  `}
`;

export const TpvModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: fit-content;
  height: fit-content;
  width: 100%;

  svg {
    display: block;
    margin: 20px auto 26px;
  }
`;

export const TpvModalFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 16px;
  margin-top: 36px;
  margin-bottom: 12px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.small}) {
    margin-bottom: 48px;
  }
`;
